import { useEffect, useId, useRef, useState } from 'react';
import { MoreHorizontal } from 'lucide-react';

// The phone header's overflow: the header's actions as menu items. Escape or
// an outside tap closes it and returns focus to the button.
export function MoreMenu({ items }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const button = useRef(null);
  const menu = useRef(null);
  const close = (focus = true) => { setOpen(false); if (focus) button.current?.focus(); };

  useEffect(() => {
    if (!open) return undefined;
    menu.current?.querySelector('[role="menuitem"]')?.focus();
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    const onDown = (e) => { if (!menu.current?.contains(e.target) && !button.current?.contains(e.target)) close(false); };
    document.addEventListener('keydown', onKey);
    document.addEventListener('pointerdown', onDown);
    return () => { document.removeEventListener('keydown', onKey); document.removeEventListener('pointerdown', onDown); };
  }, [open]);

  const onMenuKey = (e) => {
    const all = [...(menu.current?.querySelectorAll('[role="menuitem"]') ?? [])];
    const at = all.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); all[(at + 1) % all.length]?.focus(); }
    if (e.key === 'ArrowUp') { e.preventDefault(); all[(at - 1 + all.length) % all.length]?.focus(); }
  };

  return (
    <div className="ph-more">
      <button ref={button} type="button" className="ledger-icon-btn" aria-label="More" aria-haspopup="menu"
              aria-expanded={open} aria-controls={id} onClick={() => setOpen(o => !o)}>
        <MoreHorizontal aria-hidden="true" style={{ width: 18, height: 18 }} />
      </button>
      {open ? (
        <div ref={menu} id={id} role="menu" aria-label="More" className="ph-menu" onKeyDown={onMenuKey}>
          {items.map(item => (
            <button key={item.label} type="button" role="menuitem" className="ph-menu-item" disabled={item.disabled}
                    onClick={() => { close(); item.onSelect(); }}>
              {item.icon}<span>{item.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default MoreMenu;
